module.exports = __webpack_public_path__ + "static/media/bat5.f434b0c2.png";